export default __webpack_public_path__ + "static/media/luoghi.e54f143f.jpg";